/**
 * @file Contains hook for creating compose form redirect actions
 */
import { useNavigate } from 'react-router-dom';

import { ComposeNodeId } from '../props';

import useRedirectPaths from './useRedirectPaths';

/**
 * Get compose form redirect actions after submit/cancel
 *
 * @param nodeId Id of the node (whether user is editing template)
 *
 * @returns      Object with redirect actions for submit/cancel
 */
const useComposeActionsRedirect = (nodeId: ComposeNodeId) => {
  const navigate = useNavigate();
  const [cancelRedirectPath, submitRedirectPath] = useRedirectPaths(nodeId);

  /**
   * Redirect on clear compose form
   */
  const requestCancelRedirect = () => {
    if (cancelRedirectPath !== null) {
      navigate(cancelRedirectPath);
    }
  };

  /**
   * Redirect on submit compose form
   */
  const requestSubmitRedirect = () => {
    if (submitRedirectPath !== null) {
      navigate(submitRedirectPath);
    }
  };

  return { requestCancelRedirect, requestSubmitRedirect };
};

export default useComposeActionsRedirect;
